<template>
    <div class="modal"
         v-bind:class="{ 'is-active': isActive}"
    >
        <div class="modal-background"></div>

        <div class="modal-card">
            <header class="modal-card-head">
                <button  @click="toggleVisibility()"  class="delete" aria-label="close"></button>
            </header>
            <section class="modal-card-body">
                <slot></slot>
            </section>
        </div>
    </div>
</template>

<script>
    export default {
        name: "modal",
        props: ['content', 'isActive'],
        data() {
            return {
                message: 'Hello World',
            };
        },
        methods: {
            toggleVisibility() {
                this.$emit("update-modal", false);
            }
        }


    };
</script>

<style scoped lang="scss">
    .modal {
        z-index: 2000;
    }
    
    .modal-card{
        height: 90%;
    }

</style>
